import { forwardRef, Ref, type SVGProps } from 'react';

const SvgCheckboxCheckIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5 10 3 3 7-7"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckboxCheckIcon);
export default ForwardRef;
